<template>
  <div class="upload" style="padding-bottom: 200px;">
    <div v-if="!isTransfer" @click="isBack = true" style="z-index: 9999999; width: 100px; height: 46px; position: fixed; top: 0; left: 0; background: transparent;">
    </div>
    <p class=" ">转账记录</p>
    <div class="image-tan">
      <input
        type="file"
        accept="image/*,application/pdf"
        class="image"
        id="uploadImage"
        style="visibility: hidden"
        @change="pic ? selectFileImage($event, '') : initAdd($event)"
      />
      <label for="uploadImage">
        <van-image class="showimage-tan" :src="pic || defaultPic"></van-image>
      </label>
      <div
        v-if="pic"
        style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
        @click="handleDelete(pdf_name ? 'transfer_pdf' : 'transfer_photo', 'pic', 'pdf_name')"
        block
        size="small"
      >
        <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
      </div>
    </div>
    <div v-if="pdf_name" class="pdf-name">{{pdf_name}}</div>
    <div class="image-tan">
      <input
        type="file"
        accept="image/*,application/pdf"
        class="image"
        id="uploadImage1"
        style="visibility: hidden"
        @change="pic1 ? selectFileImage($event, 1) : initAdd($event)"
      />
      <label for="uploadImage1">
        <van-image class="showimage-tan" :src="pic1 || defaultPic"></van-image>
      </label>
      <div
        v-if="pic1"
        style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
        @click="handleDelete(pdf_name1 ? 'transfer_pdf1' : 'transfer_photo1', 'pic1', 'pdf_name1')"
        block
        size="small"
      >
        <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
      </div>
    </div>
    <div v-if="pdf_name1" class="pdf-name">{{pdf_name1}}</div>
    <div class="image-tan">
      <input
        type="file"
        accept="image/*,application/pdf"
        class="image"
        id="uploadImage2"
        style="visibility: hidden"
        @change="pic2 ? selectFileImage($event, 2) : initAdd($event)"
      />
      <label for="uploadImage2">
        <van-image class="showimage-tan" :src="pic2 || defaultPic"></van-image>
      </label>
      <div
        v-if="pic2"
        style="z-index: 99;position: absolute; top: 0px; right: 0px;color: white;z-index: 99; font-size:24px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 30px; height: 30px;border-radius: 0 0 0 30px;"
        @click="handleDelete(pdf_name2 ? 'transfer_pdf2' : 'transfer_photo2', 'pic2', 'pdf_name2')"
        block
        size="small"
      >
        <div style="position: absolute; top: -5px; right: -4px;width: 30px; height: 30px;display: flex; justify-content: center; align-items: center;">x</div>
      </div>
    </div>
    <div v-if="pdf_name2" class="pdf-name">{{pdf_name2}}</div>
    <div class="upload-tip theme-color">点击图片上传或更新（jpg/jpeg/png/pdf）</div>
    <div style="position: fixed; bottom: 0; left: 0; right: 0;background-color: white; padding-bottom: 10px;padding-left: 10px; padding-right: 10px;">
      <van-checkbox name="是" shape="square" :model-value="isTransfer" @update:model-value="this.handleTransfer">
        <div style="padding: 10px; position: relative;font-size: 14px; line-height: 16px;">
          本人明白并同意，于入金成功、完成开户及身份验证后，公司将直接处理因验证所需而存入之港币 10,000 元或以上银行转账之退款手续，并退回至本人同一指定入金账户，公司无需本人另行提交或签署任何提款指示。 本人确认已阅读并接受有关条款。 如有需要，本人同意贵公司将本勾选同意之动作，视为本人之正式提款指示。
        </div>
        <div v-if="isBack && !isTransfer" style="margin-left: 10px;color: #ff4444;">请勾选转账退款说明</div>
      </van-checkbox>
    </div>
    <div class="common-transferacc-tip theme-color">
      <span>提示：</span><br />
      <span>1.必须为香港的银行转账, 转账不少于1万的港币或等值美元，转账时请备注XXX开户（XXX为您的姓名）。</span><br />
      <span>2.点击查看 <span class="link" @click="handleShowAccount">收款账户</span></span><br />
      <span>3.示例（点击可查看）：<span class="link" @click="showPreview('https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/temp_3address_01.jpg')">
        转账记录
    </span>。</span><br />
  </div>

  </div>
</template>

<script>
import {
  Uploader, Image, ImagePreview, Dialog, Checkbox,
} from 'vant';
import { useStore } from 'vuex';
import { onMounted, ref } from 'vue';
import httpApi from '../../utils/httpApi';
import uploadImage from './uploadImage';
import util from '../../utils/util';

const alertMsg = `
注意：
1.必须用认证身份所绑定的银行卡转账不少于1万的港币或等值美元；
2.若未及时上传汇款凭证，后续请将凭证发送到customer-service@beevestsec.com，以便加快核实。

港币账户
银行名称： DBS Bank (Hong Kong) Limited
SWIFT码： DHBKHKHHXXX 
户口名称： BEEVEST SECURITIES LIMITED 
银行代码： 016
账户号码： 478-002183148
附注：“Client Account Name” & “Account Number”

美元账户
银行名称： DBS Bank (Hong Kong) Limited
SWIFT码： DHBKHKHHXXX 
户口名称： BEEVEST SECURITIES LIMITED - CLIENT AC
银行代码： 016
账户号码： 478-002183148
附注："“Client Account Name”"& “Account Number”
`;
const defaultPdf = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/7_pdf.png';
const defaultImage = 'https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/image/3_live.png';
export default {
  name: 'Home',
  components: {
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      defaultPic: defaultImage,
    };
  },
  methods: {
    initAdd($event) {
      if (!this.pic) return this.selectFileImage($event, '');
      if (!this.pic1) return this.selectFileImage($event, 1);
      if (!this.pic2) return this.selectFileImage($event, 2);
      return null;
    },
    handleDelete(type, key, key2) {
      httpApi.deleteFile({ type }).then((res) => {
        if (res.code === 200) {
          this.refreshData();
          this.$toast('删除成功');
          if (key) this[key] = '';
          if (key2) this[key2] = '';
        } else {
          this.refreshData();
          this.$toast(res.msg || '删除失败、请重试');
        }
      });
    },
    handleTransfer(val) {
      console.log(val);
      this.isTransfer = val;
      httpApi.submitTransfer({ agreeTransfer: val ? 1 : 0 });
    },
    handleShowAccount() {
      Dialog.alert({
        title: '收款账户',
        messageAlign: 'left',
        confirmButtonText: '我知道了',
        message: alertMsg,
        confirmButtonColor: 'rgba(0,0,0,0.6)',
      });
    },
    async selectFileImage(event, idx) {
      const file = event.target.files[0];
      if (file.type === 'application/pdf') {
        const form = new FormData();
        form.append('file', file, this.$util.setPdfName(file.name));
        const result = await this.$api.uploadPdf(`transfer_pdf${idx}`, form);
        const { data = {} } = (result || { data: {} }).data;
        if (data.fileName.endsWith('.pdf')) {
          this[`pic${idx}`] = defaultPdf;
          this[`pdf_name${idx}`] = this.$util.formatPdfName(data.fileName);
        }
      } else {
        uploadImage(file, `transfer_photo${idx}`, (photo) => {
          this[`pic${idx}`] = photo;
          this[`pdf_name${idx}`] = '';
        });
      }
    },
    showPreview(key) {
      ImagePreview([key]);
    },
    next() {
      this.$router.push({ path: '/info2' });
    },
    before() {
      this.$router.go(-1);
    },
  },
  setup() {
    const fileList = ref([]);
    const pic = ref('');
    const pdf_name = ref('');
    const pic1 = ref('');
    const pdf_name1 = ref('');
    const pic2 = ref('');
    const pdf_name2 = ref('');
    const isTransfer = ref(false);
    const isBack = ref(false);
    const store = useStore();
    store.commit('setTitleValue', '上传资料');
    store.commit('setStepsShow', false);
    const refreshData = async () => {
      fileList.value = [];
      pic.value = '';
      pdf_name.value = '';
      pic1.value = '';
      pdf_name1.value = '';
      pic2.value = '';
      pdf_name2.value = '';
      isTransfer.value = false;
      isBack.value = false;
      const result = await httpApi.getUploadImgesByType({ type: 'transfer_photo' });
      if (result && result.data && result.data.value) {
        const { value } = result.data;
        if (value.endsWith('.pdf')) {
          pic.value = defaultPdf;
          pdf_name.value = util.formatPdfName(value);
        } else {
          pic.value = value;
        }
      }
      const result1 = await httpApi.getUploadImgesByType({ type: 'transfer_photo1' });
      if (result1 && result1.data && result1.data.value) {
        const { value } = result1.data;
        if (value.endsWith('.pdf')) {
          pic1.value = defaultPdf;
          pdf_name1.value = util.formatPdfName(value);
        } else {
          pic1.value = value;
        }
      }
      const result2 = await httpApi.getUploadImgesByType({ type: 'transfer_photo2' });
      if (result2 && result2.data && result2.data.value) {
        const { value } = result2.data;
        if (value.endsWith('.pdf')) {
          pic2.value = defaultPdf;
          pdf_name2.value = util.formatPdfName(value);
        } else {
          pic2.value = value;
        }
      }
      const isTrans = await httpApi.getSubmitTransfer();
      if (isTrans) {
        isTransfer.value = isTrans.data.agreeTransfer;
      }
    };
    onMounted(async () => {
      refreshData();
    });
    return {
      pic,
      pdf_name,
      pic1,
      pdf_name1,
      pic2,
      pdf_name2,
      fileList,
      isTransfer,
      isBack,
      refreshData,
    };
  },
};
</script>

<style lang="less">
  .image-tan {
    margin-bottom: 20px !important;
    width: 300px;
    height: 200px;
    margin: auto;
    position: relative;
  }
  .showimage-tan {
    position: absolute;
    width: 300px;
    height: 200px;
    top: 0;
    left: 0;
  }
  .upload-tip {
    text-align: center !important;
    color: @font-color-2;
    margin-top: @space-2;
  }
  .upload {
    p {
      margin-top: 4px;
      margin-bottom: 4px;
    }
  }
  .common-transferacc-tip {
    margin-top: 10px;
    color: @font-color-1;
  }
  .pdf-name {
    margin: auto;
    text-align: center !important;
    margin: 20px;
  }
</style>
